







































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import Translation from '@/mixins/Translation'
import BttPopup from '@/components/popup/btt/BttPopup.vue'
import Datepicker from 'vuejs-datepicker'
import {ko} from 'vuejs-datepicker/src/locale'

@Component({
  components: {BttPopup, Datepicker},
})
export default class SelectDatePopup extends Mixins(Translation) {
  @Prop({default: 'terms', type: String}) translation: string
  @Prop({default: false, type: Boolean}) value: boolean
  @Prop({default: '', type: [Date, String]}) selectedDate: Date | string
  @Prop({default: '', type: [Date, String]}) defaultDate: Date | string
  @Prop({default: () => ({}), type: Object}) disabledDates: object
  @Prop({default: true, type: Boolean}) visibleDelete: boolean

  open: boolean = false
  language: object = ko
  date: Date | string = ''

  @Watch('value')
  __value(value) {
    this.open = value
    if(value) {
      if(this.selectedDate) {
        this.date = this.selectedDate
      } else if(this.defaultDate) {
        this.date = this.defaultDate
      }
    }
  }

  onSelected(value) {
    this.date = value
  }

  onClickConfirm() {
    this.$emit('select-date', this.date)
    this.onHandlePopup(false)
  }

  onClickDelete() {
    this.date = ''
    this.$emit('select-date', '')
    this.onHandlePopup(false)
  }

  onHandlePopup(value) {
    this.$emit('input', value)
  }
}
